import React, { useEffect, useState } from 'react'
import {
    Typography,
    Paper,
    FormControl,
    FormHelperText,
    Input,
    InputLabel,
    IconButton,
    Button
} from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import firebase from '../firebase'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next'
import InputAdornment from '@material-ui/core/InputAdornment'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import DeleteIcon from '@material-ui/icons/Delete'
import app from 'firebase/app'
import * as moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        margin: theme.spacing(1),
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'top center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			backgroundPosition: 'center center',
		},
    },
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
		},
    },
    submit: {
        padding: 12,
        marginTop: theme.spacing(3),
    },
    iconbutton: {
        width: 64, height: 64,
        padding: 0,
    },
    icon: {
        width: 64, height: 64,
    },
    input: {
        fontSize: 48,
    },
    customAlert: {
        marginLeft: theme.spacing(9),
        marginRight: theme.spacing(1),
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        boxShadow: theme.shadows[5],
        padding: `${theme.spacing(1)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    alertButton: {
        margin: theme.spacing(1),
        fontWeight: 500,
        borderWidth: 2,
        '&:hover': {
            borderWidth: 2,
        },
    },
    formHelper: {
        marginTop: theme.spacing(1),
        textAlign: 'center',
    },
})

function Account(props) {
    const { classes } = props
    const { t, i18n } = useTranslation()
    const [logged, setLogged] = useState(false)
    const [password, setPassword] = useState('')
    const [currentpassword, setCurrentpassword] = useState('')
    const [newpassword, setNewpassword] = useState('')
    const [newrepeat, setNewrepeat] = useState('')
    const [isadmin, setIsadmin] = useState(false)
    const [values, setValues] = useState({
        showPassword: false,
        showPassword2: false,
        showPassword3: false,
        showPassword4: false
    })

    useEffect(() => {
        document.title = window.localStorage.getItem('apptitle') + ` - ${t('account.label')}`
    }, [t])

    moment.locale(i18n.language)

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            setLogged(true)
            return
        } else {
            alert(t('loginfirst.label'))
            window.location.href = '/login'
            return null
        }
    }, [t])

    useEffect(() => {
        if (!firebase.auth.currentUser.emailVerified) {
            alert(t('verify.label'))
            props.history.replace('/')
        } else {
            return
        }
    }, [t, props.history])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            firebase.checkClaims().then((idTokenResult) => {
                if (!!idTokenResult.claims.admin) {
                    setIsadmin(true)
                } else {
                    return
                }
            })
        }
    }, [])

    useEffect(() => {
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== newpassword) {
                return false
            }
            return true
        })
        return () => {
            ValidatorForm.removeValidationRule('isPasswordMatch')
        }
    }, [newpassword])

    const showPassword = () => {
        setValues({ showPassword: !values.showPassword })
    }

    const showPassword2 = () => {
        setValues({ showPassword2: !values.showPassword2 })
    }

    const showPassword3 = () => {
        setValues({ showPassword3: !values.showPassword3 })
    }

    const showPassword4 = () => {
        setValues({ showPassword4: !values.showPassword4 })
    }

    const resetPassword = async (currentpassword, newpassword) => {
        try {
            var user = await firebase.auth.currentUser
            var cred = await app.auth.EmailAuthProvider.credential(user.email, currentpassword)
            var newPassword = await newpassword
            await user.reauthenticateWithCredential(cred)
            await user.updatePassword(newPassword)
            await firebase.logout().then(() => {
                window.location.href = '/'
            })
            toast.success(`${t('pwdreset.label')}`)
        }
        catch (error) {
            toast.error(`${t('pwderror.label')}`)
        }
    }

    const deleteAccount = (password) => {
        var user = firebase.auth.currentUser
        var userId = firebase.auth.currentUser.uid
        var cred = app.auth.EmailAuthProvider.credential(user.email, password)
        user.reauthenticateWithCredential(cred)
            .then(() => {
                if (isadmin) {
                    firebase.removeAdmin(userId)
                        .then(() => {
                            user.delete().then(function () {
                                firebase.logout()
                                    .then(() => {
                                        window.location.href = '/'
                                    })
                            }).catch(function (error) {
                                console.log('Error while deleting user')
                            })
                        })
                } else {
                    user.delete().then(function () {
                        firebase.logout()
                            .then(() => {
                                window.location.href = '/'
                            })
                    }).catch(function (error) {
                        console.log('Error while deleting user')
                    })
                }
            }).catch((error) => {
                toast.error(`${t('accountdelerror.label')}`)
            })
    }

    return (
        <main className={classes.main}>
            {logged ?
                <span>
                    <Paper className={classes.paper}>
                        <Typography variant="h6" gutterBottom>
                            {t('account.label')}
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            {firebase.auth.currentUser.email}
                        </Typography>
                    </Paper>

                    <Paper className={classes.paper}>
                        <Typography variant="h6">
                            {t('resetpassword.label')}
                        </Typography>
                        <br />
                        <Typography variant="body1">
                            {t('howchangepassword.label')}
                        </Typography>

                        <ValidatorForm
                            onSubmit={resetPwd}
                            style={{ textAlign: 'center' }}
                        >
                            <TextValidator
                                margin="normal"
                                label={t('oldpassword.label')}
                                onChange={e => setCurrentpassword(e.target.value)}
                                onSubmit={e => (e.target.reset())}
                                name="password"
                                type={values.showPassword ? 'text' : 'password'}
                                validators={['required']}
                                errorMessages={[t('fieldrequired.label')]}
                                value={currentpassword}
                                helperText={t('entercurrent.label')}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Toggle password visibility" onClick={showPassword}>
                                                {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <br />
                            <TextValidator
                                margin="normal"
                                label={t('newpassword.label')}
                                onChange={e => setNewpassword(e.target.value)}
                                onSubmit={e => (e.target.reset())}
                                name="newpassword"
                                type={values.showPassword2 ? 'text' : 'password'}
                                validators={['required']}
                                errorMessages={[t('fieldrequired.label')]}
                                value={newpassword}
                                helperText={t('enternew.label')}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Toggle password visibility" onClick={showPassword2}>
                                                {values.showPassword2 ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <br />
                            <TextValidator
                                margin="normal"
                                label={t('confirmnewpassword.label')}
                                onChange={e => setNewrepeat(e.target.value)}
                                name="newrepeat"
                                type={values.showPassword3 ? 'text' : 'password'}
                                validators={['isPasswordMatch', 'required']}
                                errorMessages={[t('passwordmismatch.label'), t('fieldrequired.label')]}
                                value={newrepeat}
                                helperText={t('enterrepeatnew.label')}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Toggle password visibility" onClick={showPassword3}>
                                                {values.showPassword3 ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <br /><br />
                            <Button
                                type="submit"
                                variant="outlined"
                                color="secondary"
                                className={classes.submit}>
                                {t('changepassword.label')}
                            </Button>
                            <Typography variant="body2" style={{ marginTop: '2%', marginBottom: '1%', marginLeft: '5%', marginRight: '5%' }}>
                                {t('howchangepassword2.label')}
                            </Typography>
                        </ValidatorForm>
                    </Paper>

                    <Paper className={classes.paper}>
                        <Typography variant="h6">
                            {t('deleteaccount.label')}
                        </Typography>
                        <form style={{ textAlign: 'center' }}>
                            <FormControl margin="normal" required>
                                <InputLabel htmlFor="password">{t('password.label')}</InputLabel>
                                <Input
                                    id="password"
                                    name="password"
                                    autoComplete="off"
                                    type={values.showPassword4 ? 'text' : 'password'}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    onSubmit={e => (e.target.reset())}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Toggle password visibility" onClick={showPassword4}>
                                                {values.showPassword4 ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText style={{ textAlign: 'center', lineHeight: '1.2em' }}>{t('howdeleteaccount.label')}</FormHelperText>
                            </FormControl>
                            <br />
                            <FormControl style={{ textAlign: 'center', alignContent: 'center', alignItems: 'center' }}>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    color="primary"
                                    disabled={!password}
                                    onClick={removeAccount}
                                    className={classes.submit}>
                                    {t('remove.label')}
                                    <DeleteIcon className={classes.rightIcon} />
                                </Button>
                            </FormControl>
                        </form>
                    </Paper>
                </span>
                :
                <span></span>
            }
        </main >
    )

    function resetPwd() {
        resetPassword(currentpassword, newpassword)
    }

    function removeAccount(e) {
        e.preventDefault()
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className={classes.customAlert}>
                        <Typography variant="h5" display="block" gutterBottom>
                            <strong>{t('sure.label')}?</strong>
                        </Typography>
                        <Typography variant="body2" display="block" gutterBottom>
                            {t('wantremoveaccount.label')}?
						</Typography>
                        <Button
                            type="submit"
                            variant="outlined"
                            color="primary"
                            onClick={async function () {
                                try {
                                    await deleteAccount(password)
                                    onClose()
                                } catch (error) {
                                    alert(error.message)
                                }
                            }}
                            className={classes.alertButton}>
                            {t('yes.label')}
                        </Button>
                        <Button
                            type="submit"
                            variant="outlined"
                            onClick={onClose}
                            color="primary"
                            className={classes.alertButton}>
                            {t('no.label')}
                        </Button>
                    </div>
                )
            }
        })
    }
}

export default withRouter(withStyles(styles)(Account))